import { Caption, useStyles } from '@archipro-design/aria';

import * as S from './TestimonialSlide.style';

interface SlideProps {
    content: string;
    source?: string | null;
}

export const TestimonialSlideMobile: React.FC<SlideProps> = ({
    content,
    source,
}) => {
    const { css } = useStyles();

    return (
        <div className={css(S.TestimonialSlideWrapper)}>
            <Caption
                variant={'03'}
                className={css(S.TestimonialSlideContent)}
                dangerouslySetInnerHTML={{ __html: content }}
            />
            {source && (
                <Caption
                    variant={'04'}
                    className={css(S.TestimonialSourceMobile)}
                    dangerouslySetInnerHTML={{ __html: source }}
                    weight={'medium'}
                ></Caption>
            )}
        </div>
    );
};
